import { isPast, isValid, parse } from "date-fns";
import { LStorage } from "store/config/constants";

/**
 * @returns {boolean} true, если сессия истекла, отсутствует или произошла ошибка чтения.
 */
export const isSessionExpired = () => {
  try {
    const expirationDateStr = localStorage.getItem(LStorage.EXPIRATION_DATE);

    if (!expirationDateStr) {
      return true;
    }

    const expirationDate = parse(
      expirationDateStr, 
      'dd/MM/yyyy HH:mm:ss', 
      new Date() // Базовая дата для значений, которых нет в строке
    );

    if (!isValid(expirationDate)) {
      console.warn('[Auth]: Некорректный формат даты в localStorage. Ожидается dd/MM/yyyy HH:mm:ss');
      return true;
    }

    // isPast вернет true, если дата находится в прошлом относительно текущего времени
    return isPast(expirationDate);

  } catch (error) {
    console.error('[Auth]: Ошибка доступа к localStorage', error);
    return true; 
  }
};